// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8d64e6bd","977":"14220661"}[chunkId] + ".chunk.js";
};